import * as React from "react";
import * as ReactDOM from "react-dom";
import {resourceStrings} from "../../../Intercom.ReactUI/Views/Strings";

export interface ChannelEnabledPanelProps extends React.Props<ChannelEnabledPanel> {
    channelName: string;
    message: string;
    showErrorIcon: boolean;
    title: string;
}

export interface ChannelEnabledPanelState {
}

export class ChannelEnabledPanel extends React.Component<ChannelEnabledPanelProps, ChannelEnabledPanelState> {
    constructor(props) {
        super(props);
        this.state = {}
    }

    public render(): JSX.Element {

        var icon = this.props.showErrorIcon ? <span className={("icon-font status-icon") }>{'\uE7BA'}</span> : null;

        return (
            <div className="bot-status-panel">
                <div className="dialog-close-button"></div>
                <h2>{this.props.channelName}</h2>
                <p>
                    {icon}
                    <div className={'status-text ' + (this.props.showErrorIcon ? 'has-icon' : '') }>
                        {this.props.message}
                    </div>
                </p>
                <div className="button-panel">
                    <button type="submit" className="ok-button default-button">{resourceStrings.buttonOk}</button>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./Client/Views/ChannelEnabledPanel.tsx